import colors from 'constants/colors';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MapRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  row-gap: 30px;
  padding: ${({scale}) => (`0 ${scale * 150 - 145}px`)};

  .floor {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .floorNumber {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      margin-left: ${({scale}) => ((scale * -300 + 300) + 'px')};
      margin-bottom: ${({scale}) => ((scale * 150 - 130) + 'px')};
      cursor: pointer;

      .type {
        font-size: 16px;
        font-weight: bold;
        color: ${colors.grey};
        letter-spacing: 2.5px;
      }

      .number {
        font-size: 16px;
        font-weight: bold;
        color: ${colors.white};
        letter-spacing: 2.5px;
        margin-left: 12px;
      }
    }
  }

  @media only screen and (max-width:1200px){
    flex-direction: column;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  padding: 20px;
`;

export const ViewLegend = styled.div`
  color: ${({active})=>active? colors.lightBlue: colors.white};
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
  width: 15%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE10+/Edge */
  user-select: none;         /* standard */

  img {
    width: 34px;
    height: 25px;
    display: inline-block;
    margin-right: 10px;
  }

  div {
    padding: 5px;
  }
  cursor: pointer;

  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

export const FloorCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
  background-color: ${colors.black1};
  letter-spacing: 1px;
  height: calc(100vh - 130px);
  min-height: 400px;

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    min-height: 460px;
  }

  @media only screen and (min-width: 501px) and (max-width: 767px) {
    min-height: 570px;
  }

  @media only screen and (min-width: 401px) and (max-width: 500px) {
    min-height: 490px;
  }

  @media only screen and (min-width: 375px) and (max-width: 400px)  {
    min-height: 460px;
  }

  @media only screen and (max-width: 374px) {
    min-height: 430px;
  }

  .type {
    font-size: 16px;
    font-weight: bold;
    color: ${colors.grey};
  }

  @media only screen and (min-width: 1200px) {
    display: none;
  }
`;
